import { Header } from "../misc";
import { MonthlyCalendar } from "./UI/MonthlyCalendar";
import { WeeklyCalendar } from "./UI/WeeklyCalendar";

/**
 * ### [Route for ('/calendar/weekly')]
 *
 * This component shows the calendar for the current week.
 * The calendar shows projects that are due in that week.
 */
export function WeeklyCalendarPage() {
	return <WeeklyCalendar />;
}

/**
 * ### [Route for ('/monthly_calendar')]
 *
 * This component shows the calendar for the current month.
 * The calendar shows projects that are due in that month.
 *
 * TODO:
 * - Show links to each project due
 */
export function MonthlyCalendarPage() {
	return <MonthlyCalendar />;
}

/**
 * ### [Route for ('/calendar/monthly/user')]
 *
 * This component shows the calendar for the current month,
 * filtered to only the projects assigned to the logged-in user.
 */
export function MonthlyUserProjectsCalendarPage() {
	return <MonthlyCalendar userProjectsOnly />;
}

/**
 * ### [Route for ('/calendar/weekly/user')]
 *
 * This component shows the calendar for the current week,
 * filtered to only the projects assigned to the logged-in user.
 */
export function WeeklyUserProjectsCalendarPage() {
	return <WeeklyCalendar userProjectsOnly />;
}

export function MonthlyCalendarPopup() {
	return (
		<>
			<Header />

			<MonthlyCalendar />
		</>
	);
}

export function WeeklyCalendarPopup() {
	return (
		<>
			<Header />

			<WeeklyCalendar />
		</>
	);
}
